<template>
    <Navbar />
    <div class="create-task-panel-cont" v-if="isFirstStepDone">
      <button class="btn btn-primary mt-3 align-self-start" @click="() => $router.push('/zlecenia/dodaj')"><i class="fa-solid fa-arrow-left"></i></button>
      <div class="create-task-panel-page-2">
        <h4 class="mt-5">Postoje</h4>
        <div class="stoppages-editor-cont">
          <div class="add-new-task-stoppage">
            <form @submit.prevent="addStoppageToList">
              <div class="form-group">
                <label for="newTaskStoppageSeracher">wyszukaj i wybierz postój</label>
                <div class="d-flex">
                  <input type="text" class="form-control rounded-0" name="newTaskStoppageSeracher" id="newTaskStoppageSeracher" v-model="newTaskStoppageSeracher">
                  <button type="button" @click="cancelStoppagesSearching" class="btn btn-danger rounded-0">resetuj</button>
                  <button type="button" @click="searchStoppages" class="btn btn-success rounded-0">szukaj</button>
                  <div v-if="isStoppagesSearching"><img style="max-width: 38px;" src="@/assets/spin-loader.gif" alt="ładowanie..."></div>
                </div>
                <select class="form-select mt-3" required v-model="stoppagesSelect">
                  <option selected value="firstOption">---szukane postoje---</option>
                  <option v-for="stpg in searchedStoppages" :key="stpg.name" :value="stpg.name">{{ stpg.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="newTaskStoppageArrival" class="mt-4">czas przyjazdu</label>
                <input type="datetime-local" class="form-control" name="newTaskStoppageArrival" v-model="newTaskStoppageArrival" id="newTaskStoppageArrival" required>
                <div class="mb-3">
                  <label for="newTaskStoppageDeparture" class="mt-3">czas wyjazdu <br> (niewymagany dla ostatniego postoju)</label>
                  <input type="datetime-local" class="form-control" name="newTaskStoppageDeparture" id="newTaskStoppageDeparture" v-model="newTaskStoppageDeparture" aria-label="Text input with checkbox">
                </div>
              </div>
              <button class="btn btn-success mt-5" type="submit">Dodaj do listy postoi</button>
            </form>
          </div>
        </div>
        <h4 class="mt-3">Lista postoi</h4>
        <div class="stoppages-list-cont">
          <table class="table table-dark table-striped table-bordered">
            <thead>
              <tr>
                <th>Akronim</th>
                <th>Przyjazd</th>
                <th>Wyjazd</th>
                <th>Usuń</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in newTaskStoppages" :key="`${item.acronym}-${i}`">
                <td>{{ item.acronym }}</td>
                <td>
                  {{ moment(item.przyjazd).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') }}
                  <span role="button" class="text-info" @click="updateStoppage(item, 'arrival', i)">
                    <i class="fas fa-edit"></i>
                  </span>
                </td>
                <td>
                  <span v-if="i < newTaskStoppages.length - 1">
                    {{ item.wyjazd ? moment(item.wyjazd).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') : '' }}
                    <span role="button" class="text-info" @click="updateStoppage(item, 'departure', i)">
                      <i class="fas fa-edit"></i>
                    </span>
                  </span>
                  <span v-else>
                    Dla ostatniego postoju data wyjazdu zostanie usunięta ({{ item.wyjazd ? moment(item.wyjazd).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') : '' }})
                    <span role="button" class="text-info" @click="updateStoppage(item, 'departure', i)">
                      <i class="fas fa-edit"></i>
                    </span>
                  </span>
                </td>
                <td><button class="stoppages-table-remove-btn" @click="removeStoppageFromList(item)"><i class="fa-solid fa-trash"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <button class="btn btn-primary m-2" @click="() => $router.push('/zlecenia/dodaj')"><i class="fa-solid fa-arrow-left"></i>Cofnij</button>
        <button class="btn btn-success m-2" @click="() => submitTask()">Dodaj zlecenie<i class="fa-solid fa-arrow-right"></i></button>
      </div>
    </div>
    <div v-else>
        <h2 class="mt-3">Wypełnij najpierw pierwszy formularz</h2>
        <button class="btn btn-primary" @click="() => $router.push('/zlecenia/dodaj')">powrót</button>
    </div>
  </template>

  <script>
  import Swal from 'sweetalert2'
  import Navbar from '@/components/Navbar'
  import axios from 'axios'
  import moment from 'moment-timezone'

  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Step2',
    components: {
      Navbar
    },
    data () {
      return {
        isFirstStepDone: false,
        firstStepData: null,
        newTaskStoppages: [],
        newTaskStoppageSeracher:'',
        newTaskStoppageDeparture: null,
        newTaskStoppageArrival: '',
        searchedStoppages:[],
        isStoppagesSearching: false,
        stoppagesSelect: '',
        isDepartureActive: false,
        moment: moment
      }
    },
    mounted () {
        this.getIsFirstStepDone()
    },
    methods: {
        getIsFirstStepDone(){
            window.scrollTo(null, 0)
            this.isFirstStepDone = this.$store.getters.getIsFirstStepDone
        },
        searchStoppages(){
            if(this.newTaskStoppageSeracher.length >= 3){
                this.isStoppagesSearching = true
                const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
                axios.get(`${process.env.VUE_APP_API_BASE_URL}Place`, config)
                    .then(res => {
                        this.searchedStoppages = res.data.filter(place => place.name.toLowerCase().includes(this.newTaskStoppageSeracher.toLowerCase()) || place.address.toLowerCase().includes(this.newTaskStoppageSeracher.toLowerCase()))
                        this.isStoppagesSearching =  false
                    }).catch(err => {
                        console.log(err);
                        this.isStoppagesSearching =  false
                    })
            }
        },
        cancelStoppagesSearching(){
            this.newTaskStoppageSeracher = ''
            this.searchedStoppages = []
            this.isStoppagesSearching =  false
        },
        addStoppageToList(){
          const ob = {
            acronym: this.stoppagesSelect,
            przyjazd: moment(this.newTaskStoppageArrival).format('YYYY-MM-DD HH:mm'),
            wyjazd: this.newTaskStoppageDeparture ?? moment(this.newTaskStoppageArrival).add('minutes', 90).format('YYYY-MM-DD HH:mm')
          }

          if (this.newTaskStoppages.length) {
            const previousStoppage = this.newTaskStoppages[this.newTaskStoppages.length - 1]
            const previousStoppageArrival = moment.utc(previousStoppage.przyjazd)
            const previousStoppageDeparture = moment.utc(previousStoppage.wyjazd)
            const newStoppageArrival = moment.utc(ob.przyjazd)
            const newStoppageDeparture = moment.utc(ob.wyjazd)

            const isBeforeLastStoppage =
              newStoppageArrival.isBefore(previousStoppageArrival) ||
              newStoppageArrival.isBefore(previousStoppageDeparture) ||
              newStoppageDeparture.isBefore(previousStoppageArrival) ||
              newStoppageDeparture.isBefore(previousStoppageDeparture)

            if (isBeforeLastStoppage) {
              Swal.fire({
                title: `Zmiana niemożliwa, zmień godziny w punkcie ${previousStoppage.acronym} lub w obecnie edytowanym punkcie`,
                icon: 'warning'
              })
            } else {
              if (newStoppageDeparture.isBefore(newStoppageArrival)) {
                Swal.fire('Data wyjazdu nie może być wcześniejsza od daty przyjazdu', '', 'warning')
              } else {
                this.pushStoppage(ob)
              }
            }
          }

          if (!this.newTaskStoppages.length) {
            this.pushStoppage(ob)
          }
        },
        pushStoppage (ob) {
          this.newTaskStoppages.push(ob)
          this.cancelStoppagesSearching()
          this.newTaskStoppageArrival = ''
          this.newTaskStoppageDeparture = null
        },
        removeStoppageFromList(item){
            this.newTaskStoppages.push(this.newTaskStoppages.splice(this.newTaskStoppages.indexOf(item), 1)[0]);
            this.newTaskStoppages.pop()
        },
        async updateStoppage (stoppage, key, stoppageIndex) {
          const oldDate = key === 'arrival' ? stoppage.przyjazd : stoppage.wyjazd
          await Swal.fire({
            title: `Zaktualizuj datę ${key === 'arrival' ? 'przyjazdu' : 'wyjazdu'} w postoju ${stoppage.acronym}`,
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Anuluj',
            showConfirmButton: true,
            confirmButtonText: 'Zatwierdź',
            html: `
            <div>${key === 'arrival' ? 'Data przyjazdu' : 'Data wyjazdu'}:</div>
            <input class="form-control" id="new-date" type="datetime-local" value="${moment(oldDate).format('YYYY-MM-DD HH:mm')}" required>
          `,
            preConfirm: () => {
              return new Promise(resolve => {
                const date = document.getElementById('new-date').value

                if (date === '') {
                  Swal.fire('Proszę uzupełnić datę', '', 'warning')
                } else {
                  resolve(date)
                }
              }).then(result => {
                if (key === 'arrival') {
                  this.newTaskStoppages[stoppageIndex].przyjazd = result
                }

                if (key === 'departure') {
                  this.newTaskStoppages[stoppageIndex].wyjazd = result
                }
              })
            }
          })
        },
        submitTask(){
            if(this.newTaskStoppages.length >= 2){
                const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
                this.firstStepData = this.$store.getters.getCreateTaskStepOneData
                const route = []
                this.newTaskStoppages.forEach((x, i) => {
                  route.push(x.acronym)
                  this.newTaskStoppages[i].backgroundColor = '#ffffff'
                })
                this.newTaskStoppages.map((s, i) => {
                  if (i === this.newTaskStoppages.length - 1) {
                    this.newTaskStoppages[i].wyjazd = null
                  }
                })
                const postData = {
                    textColor: this.firstStepData.tc,
                    altTextColor: this.firstStepData.tc,
                    backgroundColor: this.firstStepData.bgc,
                    altBackgroundColor: this.firstStepData.bgc,
                    numer_Przejazdu: this.firstStepData.vrid,
                    przewoznik: this.firstStepData.cmpName,
                    linia: route.join('->'),
                    szacunkowy_Koszt: this.firstStepData.rate,
                    postoje: this.newTaskStoppages,
                    waluta: this.firstStepData.currency,
                    zaladunek: this.getLoadingAndUnloading()[0],
                    rozladunek: this.getLoadingAndUnloading()[this.getLoadingAndUnloading.length == 0 ?  0 : this.getLoadingAndUnloading.length-1],
                    freightForwarder: this.firstStepData.forwarder,
                    description1: this.firstStepData.desc1,
                    description2: this.firstStepData.desc2,
                    description3: this.firstStepData.desc3
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}Task`, postData, config)
                    .then(() => {
                      Swal.fire('Pomyślnie dodano zlecenie', '', 'success')
                      this.resetNewTaskData()
                      this.$router.push('/zlecenia')
                    }).catch(err => {
                      let swalMessage = 'Coś poszło nie tak'

                      if (err.response.data === 'Numer_Przejazdu is duplicated.') {
                        swalMessage = 'Postój po podanym VRID już istnieje w bazie danych, nie można zduplikować zadania'
                      }

                      Swal.fire(swalMessage, '', 'error')
                    })
            }else{
                Swal.fire('Proszę uzupełnić minimum dwa postoje zlecenia', 'Przynajmniej dwa postoje muszą zostać dodane', 'error')
            }

        },
        getLoadingAndUnloading(){
            const time = []
            this.newTaskStoppages.forEach(x => {
                if(x.wyjazd !== null){
                    time.push(x.wyjazd)
                }
                if(x.przyjazd !== null){
                    time.push(x.przyjazd)
                }
            })
            let sortedTime = time.sort((a,b) => {
                return new Date(a) - new Date(b)
            })
            return sortedTime
        },
        resetNewTaskData(){
            this.$store.commit('setCreateTaskStepOneData', {})
            this.$store.commit('setIsFirstStepDone', false)
            this.newTaskStoppageSeracher = ''
            this.searchedStoppages = []
            this.newTaskStoppageArrival = ''
            this.newTaskStoppageDeparture = ''
            this.newTaskStoppages = []
        }
    }
  }
  </script>

  <style>
    .create-task-panel-cont{
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1100px;
      margin: 0 auto;
      padding-bottom: 100px;
    }
    .stoppages-list-cont{
      max-width: 600px;
    }
    .stoppages-table-remove-btn{
      color: #ff0000;
      border: none;
      background: none;
      cursor: pointer;
    }
    .stoppages-editor-cont {
      width: 600px;
    }
  </style>
